
import { Vue, Component, toNative } from 'vue-facing-decorator';
import MyInformationView from '@/components/Participants/MyInformation/MyInformationView.vue';
import { Root } from '@/main';

@Component({
  components: { MyInformationView },
})
class MyInformation extends Vue {
  private mounted() {
    Root.emit('set-active-component', 'myinformation');
  }
}

export default toNative(MyInformation);
